// export const BaseApiUrl = "https://staffapi.dibru.work/api/dibru/department/";

 export const BaseApiDomain = "https://staffapi.dibru.work/api/dibru/";

//export const BaseApiDomain = "http://localhost:8000/api/dibru/";
// export const BaseApiDomain = "https://dibrudemoapi.kareng.co.in/api/dibru/";

// export const BaseApiUrl = BaseDomain + "department/";
